// Mock data for Navavidha Bhakti clone

export const upcomingPujas = [
  {
    id: 'p1',
    slug: 'shani-mahakali-sankat-nivaran-puja',
    title_en: 'Shanivar Special: Shani Mahakali Sankat Nivaran Puja',
    title_hi: 'शनिवार विशेष: शनि महाकाली संकट निवारण पूजा',
    description_en: 'Reduces Shani-related obstacles, brings mental peace, protection from negativity, career stability, karmic relief, and blessings of Lord Shani.',
    description_hi: 'शनि से जुड़ी बाधाओं को कम करती है, मानसिक शांति, नकारात्मकता से सुरक्षा, करियर स्थिरता, कर्म राहत और भगवान शनि का आशीर्वाद प्रदान करती है।',
    temple_en: 'Shani Mandir Ujjain',
    temple_hi: 'शनि मंदिर उज्जैन',
    date: '2026-07-18',
    date_label_en: 'Shanivar Special: 18 July 2026',
    date_label_hi: 'शनिवार विशेष: 18 जुलाई 2026',
    image: 'https://images.unsplash.com/photo-1693139441439-95ddfb2ecdba?w=800',
    price: 851,
    benefits_en: ['Removes Shani Dosha', 'Career growth', 'Mental peace', 'Protection from negativity'],
    benefits_hi: ['शनि दोष निवारण', 'करियर में उन्नति', 'मानसिक शांति', 'नकारात्मकता से रक्षा']
  },
  {
    id: 'p2',
    slug: 'dhan-vriddhi-and-vyapar-samriddhi-maa-mahalakshmi-puja',
    title_en: 'Gupt Navratri Special: Dhan Vriddhi Maa Mahalakshmi Puja, Shri Sukta Path and 108 Kamal Gatta Havan',
    title_hi: 'गुप्त नवरात्रि विशेष: धन वृद्धि माँ महालक्ष्मी पूजा, श्री सूक्त पाठ और 108 कमल गट्टा हवन',
    description_en: 'A powerful puja for wealth, prosperity and business growth. Includes Shri Sukta Path with 108 Kamal Gatta Havan.',
    description_hi: 'धन, समृद्धि और व्यापार वृद्धि के लिए एक शक्तिशाली पूजा। श्री सूक्त पाठ और 108 कमल गट्टा हवन शामिल है।',
    temple_en: 'Maa Ambabai Mahalaxmi Teerth Kshetra Kolhapur',
    temple_hi: 'माँ अम्बाबाई महालक्ष्मी तीर्थ क्षेत्र कोल्हापुर',
    date: '2026-07-18',
    date_label_en: 'Gupt Navratri Special: 18 July 2026',
    date_label_hi: 'गुप्त नवरात्रि विशेष: 18 जुलाई 2026',
    image: 'https://images.pexels.com/photos/33643802/pexels-photo-33643802.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    price: 1101,
    benefits_en: ['Wealth abundance', 'Business growth', 'Removes financial obstacles', 'Lakshmi blessings'],
    benefits_hi: ['धन की वृद्धि', 'व्यापार में उन्नति', 'आर्थिक बाधा निवारण', 'लक्ष्मी कृपा']
  },
  {
    id: 'p3',
    slug: 'vidya-vani-and-buddhi-siddhi-maa-matangi-puja',
    title_en: 'Gupt Navratri Special: Vidya, Vani and Buddhi Siddhi Maa Matangi Puja, Mantra Jaap and Havan',
    title_hi: 'गुप्त नवरात्रि विशेष: विद्या, वाणी और बुद्धि सिद्धि माँ मातंगी पूजा, मंत्र जाप और हवन',
    description_en: 'For students, artists and seekers of knowledge. Blesses with wisdom, eloquence and intellect.',
    description_hi: 'छात्रों, कलाकारों और ज्ञान के साधकों के लिए। बुद्धि, वाणी और विद्या का आशीर्वाद।',
    temple_en: 'Maa Matangi Temple Haridwar',
    temple_hi: 'माँ मातंगी मंदिर हरिद्वार',
    date: '2026-07-19',
    date_label_en: 'Gupta Navratri Special: 19 July 2026',
    date_label_hi: 'गुप्त नवरात्रि विशेष: 19 जुलाई 2026',
    image: 'https://images.pexels.com/photos/10754769/pexels-photo-10754769.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    price: 751,
    benefits_en: ['Knowledge & Wisdom', 'Enhanced speech', 'Academic success', 'Creativity boost'],
    benefits_hi: ['ज्ञान व बुद्धि', 'वाणी शुद्धि', 'शैक्षणिक सफलता', 'सृजनात्मकता']
  },
  {
    id: 'p4',
    slug: 'maa-matangi-108-laung-ahuti-havan-and-saraswati-puja',
    title_en: 'Gupt Navratri Special: Maa Matangi 108 Laung Ahuti Havan and Saraswati Puja',
    title_hi: 'गुप्त नवरात्रि विशेष: माँ मातंगी 108 लौंग आहुति हवन और सरस्वती पूजा',
    description_en: 'Special 108 Laung Ahuti Havan combined with Saraswati Puja for divine blessings.',
    description_hi: 'दिव्य आशीर्वाद हेतु 108 लौंग आहुति हवन और सरस्वती पूजा।',
    temple_en: 'Maa Matangi Temple Haridwar',
    temple_hi: 'माँ मातंगी मंदिर हरिद्वार',
    date: '2026-07-19',
    date_label_en: 'Gupta Navratri Special: 19 July 2026',
    date_label_hi: 'गुप्त नवरात्रि विशेष: 19 जुलाई 2026',
    image: 'https://cdn.pixabay.com/photo/2016/11/23/15/39/ganesha-1853602_1280.jpg',
    price: 951,
    benefits_en: ['Removes negativity', 'Divine energy', 'Purification', 'Blessings of Saraswati'],
    benefits_hi: ['नकारात्मकता निवारण', 'दिव्य ऊर्जा', 'शुद्धिकरण', 'सरस्वती कृपा']
  },
  {
    id: 'p5',
    slug: 'ganesh-chaturthi-siddhi-vinayak-puja',
    title_en: 'Ganesh Chaturthi Special: Siddhi Vinayak Puja & Modak Bhog',
    title_hi: 'गणेश चतुर्थी विशेष: सिद्धि विनायक पूजा और मोदक भोग',
    description_en: 'Invoke Lord Ganesha for removing obstacles and bringing success in new ventures.',
    description_hi: 'नए कार्यों में सफलता और विघ्न निवारण हेतु भगवान गणेश की पूजा।',
    temple_en: 'Siddhivinayak Mandir Mumbai',
    temple_hi: 'सिद्धिविनायक मंदिर मुंबई',
    date: '2026-08-27',
    date_label_en: 'Ganesh Chaturthi: 27 August 2026',
    date_label_hi: 'गणेश चतुर्थी: 27 अगस्त 2026',
    image: 'https://cdn.pixabay.com/photo/2018/08/18/11/08/lord-3614576_1280.jpg',
    price: 651,
    benefits_en: ['Removes obstacles', 'Success in new ventures', 'Wisdom', 'Prosperity'],
    benefits_hi: ['विघ्न निवारण', 'नए कार्यों में सफलता', 'बुद्धि', 'समृद्धि']
  },
  {
    id: 'p6',
    slug: 'hanuman-chalisa-path-and-sindoor-abhishek',
    title_en: 'Mangalvar Special: Hanuman Chalisa Path & Sindoor Abhishek',
    title_hi: 'मंगलवार विशेष: हनुमान चालीसा पाठ और सिंदूर अभिषेक',
    description_en: 'Strength, courage and protection through Hanuman Ji blessings.',
    description_hi: 'हनुमान जी की कृपा से शक्ति, साहस और सुरक्षा।',
    temple_en: 'Salasar Balaji Rajasthan',
    temple_hi: 'सालासर बालाजी राजस्थान',
    date: '2026-07-22',
    date_label_en: 'Mangalvar Special: 22 July 2026',
    date_label_hi: 'मंगलवार विशेष: 22 जुलाई 2026',
    image: 'https://cdn.pixabay.com/photo/2021/07/16/17/10/monkey-king-6471387_640.png',
    price: 551,
    benefits_en: ['Removes fear', 'Strength & courage', 'Protection', 'Removes evil eye'],
    benefits_hi: ['भय निवारण', 'शक्ति व साहस', 'सुरक्षा', 'बुरी नज़र से रक्षा']
  }
];

export const howItWorksSteps = [
  { id: 1, title_en: 'Select Puja', title_hi: 'पूजा चुनें', desc_en: 'Select your Puja on preferred date', desc_hi: 'अपनी पसंदीदा तिथि पर पूजा चुनें', icon: 'ClipboardList' },
  { id: 2, title_en: 'Fill Your Details', title_hi: 'विवरण भरें', desc_en: 'Fill your Name, Gotra and Address', desc_hi: 'अपना नाम, गोत्र और पता भरें', icon: 'UserPen' },
  { id: 3, title_en: 'Puja Performed', title_hi: 'पूजा संपन्न', desc_en: 'Your puja will be performed at temple', desc_hi: 'आपकी पूजा मंदिर में की जाएगी', icon: 'Flame' },
  { id: 4, title_en: 'Watch Puja Video', title_hi: 'पूजा वीडियो देखें', desc_en: 'Watch puja video with your sankalp timing', desc_hi: 'अपनी संकल्प समय के साथ पूजा वीडियो देखें', icon: 'Video' },
  { id: 5, title_en: 'Prasad Shipped', title_hi: 'प्रसाद प्रेषण', desc_en: 'Prasad reaches within 7-10 days', desc_hi: 'प्रसाद 7-10 दिनों में आपके घर पहुँचेगा', icon: 'Package' }
];

export const testimonials = [
  { id: 1, name: 'Arti Shukla', via: 'Instagram', text_en: 'Mujhe ye Pooja karakar accha laga inhone acche se kiya aur mujhe bhaut accha laga aap bhi ye Pooja try kar sakte ho', text_hi: 'मुझे यह पूजा कराकर बहुत अच्छा लगा, उन्होंने बहुत अच्छे से कराई। आप भी यह पूजा ज़रूर करवाएं।', avatar: 'https://images.pexels.com/photos/38281680/pexels-photo-38281680.jpeg?auto=compress&cs=tinysrgb&h=200&w=200' },
  { id: 2, name: 'Ritu Singh', via: 'Facebook', text_en: 'Being part of such a beautiful Puja from home was possible because of Navavidha Bhakti. Truly felt peace of mind.', text_hi: 'घर बैठे इतनी सुंदर पूजा में शामिल होना केवल नवविधा भक्ति की वजह से ही संभव हुआ। मन को अद्भुत शांति मिली।', avatar: 'https://images.pexels.com/photos/29679833/pexels-photo-29679833.jpeg?auto=compress&cs=tinysrgb&h=200&w=200' },
  { id: 3, name: 'Kamal Kumar', via: 'Facebook', text_en: 'Liked the fact that we can book Puja online with Navavidha Bhakti, saving travel effort. Felt very nice to hear my name and gotra during the Puja. Prasad was also received on time.', text_hi: 'नवविधा भक्ति के साथ ऑनलाइन पूजा बुक करना बहुत सुविधाजनक लगा। पूजा में अपना नाम और गोत्र सुनकर मन प्रसन्न हो गया। प्रसाद भी समय पर मिल गया।', avatar: 'https://cdn.pixabay.com/photo/2023/12/01/14/34/kid-8423834_1280.jpg' },
  { id: 4, name: 'Rajat Sharma', via: 'Facebook', text_en: 'It felt good after doing the Puja, I felt peace of mind. I also received Prasad today. May Devi Maa\'s blessings always remain.', text_hi: 'पूजा के बाद बहुत शांति मिली। आज प्रसाद भी प्राप्त हुआ। देवी माँ का आशीर्वाद सदा बना रहे।', avatar: 'https://images.pexels.com/photos/38281680/pexels-photo-38281680.jpeg?auto=compress&cs=tinysrgb&h=200&w=200' },
  { id: 5, name: 'Aarav Kumar', via: 'Facebook', text_en: 'Grateful to Navavidha Bhakti for a divine online Puja experience — felt truly blessed and connected from home!', text_hi: 'नवविधा भक्ति की दिव्य ऑनलाइन पूजा अनुभव के लिए हृदय से आभारी हूँ — घर से ही असली आशीर्वाद मिला!', avatar: 'https://images.pexels.com/photos/29679833/pexels-photo-29679833.jpeg?auto=compress&cs=tinysrgb&h=200&w=200' },
  { id: 6, name: 'Amit Verma', via: 'Facebook', text_en: 'Puja is conducted properly and customer support is available throughout. Most genuine and authentic experience.', text_hi: 'पूजा बहुत विधिपूर्वक की जाती है और ग्राहक सहायता हर समय उपलब्ध रहती है। सबसे प्रामाणिक अनुभव।', avatar: 'https://cdn.pixabay.com/photo/2023/12/01/14/34/kid-8423834_1280.jpg' }
];

export const faqs = [
  {
    q_en: 'Why should I choose Navavidha Bhakti for performing a Puja?',
    q_hi: 'पूजा के लिए नवविधा भक्ति क्यों चुनें?',
    a_en: 'Navavidha Bhakti is one of the fastest-growing devotion technology platforms, trusted by 1 Lakh+ devotees. Every Puja is conducted by experienced Pandit Jis at holy pilgrimage destinations like Haridwar, Varanasi, Ujjain, and Kashi. Our Pandit Jis chant your Name and Gotra, and perform rituals as per Vedic Shastras.',
    a_hi: 'नवविधा भक्ति एक तेज़ी से बढ़ता हुआ भक्ति तकनीक प्लेटफ़ॉर्म है, जिस पर 1 लाख से अधिक भक्तों का भरोसा है। हर पूजा हरिद्वार, वाराणसी, उज्जैन और काशी जैसे तीर्थ स्थलों पर अनुभवी पंडित जी द्वारा वैदिक शास्त्रों के अनुसार की जाती है।'
  },
  {
    q_en: 'I don\'t know my Gotra, what should I do?',
    q_hi: 'मुझे अपना गोत्र नहीं पता, क्या करूँ?',
    a_en: 'Please consult elders in your family. If no one remembers, as per Shastras you can consider your Gotra as Kashyap Gotra and mention it in the Sankalpa form.',
    a_hi: 'कृपया परिवार के बुज़ुर्गों से पूछें। यदि किसी को याद न हो तो शास्त्रों के अनुसार आप कश्यप गोत्र का उल्लेख कर सकते हैं।'
  },
  {
    q_en: 'How will I know the Puja has been done in my name?',
    q_hi: 'मुझे कैसे पता चलेगा कि पूजा मेरे नाम से हुई है?',
    a_en: 'You will get the full recorded video of the Puja along with your Sankalp timing. You can hear your Sankalp at the given timestamp.',
    a_hi: 'आपको पूजा का पूरा रिकॉर्ड किया गया वीडियो आपके संकल्प समय के साथ मिलेगा, जिसमें आप अपना संकल्प सुन सकते हैं।'
  },
  {
    q_en: 'What should I do on the day of the Puja?',
    q_hi: 'पूजा वाले दिन मुझे क्या करना चाहिए?',
    a_en: 'Follow Brahmacharya and meditate on your Ishtadev. You will receive a notification from us before the Puja goes live.',
    a_hi: 'ब्रह्मचर्य का पालन करें और अपने इष्टदेव का ध्यान करें। पूजा शुरू होने से पहले आपको सूचना भेजी जाएगी।'
  },
  {
    q_en: 'Where can I contact for more information?',
    q_hi: 'अधिक जानकारी के लिए कहाँ संपर्क करें?',
    a_en: 'You can contact us at +91 9525141736 or email sishivam38@gmail.com',
    a_hi: 'आप हमसे +91 9525141736 पर संपर्क कर सकते हैं या sishivam38@gmail.com पर ईमेल कर सकते हैं।'
  }
];

export const translations = {
  nav: {
    home: { en: 'Home', hi: 'होम' },
    pujas: { en: 'Upcoming Pujas', hi: 'आगामी पूजा' },
    howItWorks: { en: 'How It Works', hi: 'कैसे काम करता है' },
    testimonials: { en: 'Devotee Corner', hi: 'भक्त कोना' },
    faq: { en: 'FAQs', hi: 'सामान्य प्रश्न' },
    login: { en: 'Login', hi: 'लॉगिन' },
    admin: { en: 'Admin', hi: 'एडमिन' },
    pandit: { en: 'Pandit', hi: 'पंडित' },
    user: { en: 'Devotee', hi: 'भक्त' },
    logout: { en: 'Logout', hi: 'लॉगआउट' },
    dashboard: { en: 'Dashboard', hi: 'डैशबोर्ड' }
  },
  hero: {
    tagline: { en: 'Navavidha Bhakti, A Sacred Bridge Connecting Devotees with Divine Pujas, Temples & Tirth Kshetras Across Bharat', hi: 'नवविधा भक्ति — भक्तों को भारत के दिव्य पूजा, मंदिरों और तीर्थ क्षेत्रों से जोड़ने वाला पवित्र सेतु' },
    subtitle: { en: 'Explore Pujas & get Blessings from home', hi: 'घर बैठे पूजाओं में भाग लें और आशीर्वाद प्राप्त करें' },
    cta1: { en: 'Participate In Pujas', hi: 'पूजा में भाग लें' },
    cta2: { en: 'Download App', hi: 'ऐप डाउनलोड करें' },
    trust: { en: 'Trusted by 1 Lakh+ Devotees Across Bharat  •  100% Secure  •  India\'s most loved devotional platform', hi: 'भारत भर में 1 लाख+ भक्तों द्वारा विश्वसनीय  •  100% सुरक्षित  •  भारत का सबसे प्रिय भक्ति मंच' }
  },
  sections: {
    upcoming: { en: 'Upcoming Pujas', hi: 'आगामी पूजा' },
    how: { en: 'How it Works', hi: 'कैसे काम करता है' },
    corner: { en: 'Devotee Corner', hi: 'भक्त कोना' },
    cornerSub: { en: 'Real experiences shared by devotees who participated in Navavidha Bhakti Pujas', hi: 'नवविधा भक्ति पूजा में शामिल भक्तों के वास्तविक अनुभव' },
    faqs: { en: 'FAQs', hi: 'सामान्य प्रश्न' },
    subscribe: { en: 'Subscribe', hi: 'सब्सक्राइब करें' },
    subscribeSub: { en: 'to Navavidha Bhakti WhatsApp', hi: 'नवविधा भक्ति व्हाट्सएप पर' },
    subscribeDesc: { en: 'If you are interested in Upcoming Pujas and Sanatan Dharma, subscribe to Navavidha Bhakti WhatsApp', hi: 'यदि आप आगामी पूजा और सनातन धर्म में रुचि रखते हैं तो नवविधा भक्ति व्हाट्सएप की सदस्यता लें' },
    subscribeBtn: { en: 'Subscribe on WhatsApp', hi: 'व्हाट्सएप पर सब्सक्राइब करें' },
    viewAll: { en: 'View All Pujas', hi: 'सभी पूजा देखें' },
    participate: { en: 'Participate Now', hi: 'भाग लें' },
    chatWa: { en: 'Chat on Whatsapp', hi: 'व्हाट्सएप पर चैट करें' }
  },
  puja: {
    at: { en: 'at', hi: 'में' },
    dayLeft: { en: 'day left', hi: 'दिन शेष' },
    benefits: { en: 'Benefits', hi: 'लाभ' },
    price: { en: 'Sankalp Contribution', hi: 'संकल्प दक्षिणा' },
    fillDetails: { en: 'Fill Your Sankalp Details', hi: 'अपना संकल्प विवरण भरें' },
    fullName: { en: 'Full Name', hi: 'पूरा नाम' },
    gotra: { en: 'Gotra (if unknown use Kashyap)', hi: 'गोत्र (अज्ञात हो तो कश्यप लिखें)' },
    phone: { en: 'Phone Number', hi: 'फ़ोन नंबर' },
    email: { en: 'Email', hi: 'ईमेल' },
    address: { en: 'Shipping Address for Prasad', hi: 'प्रसाद के लिए पता' },
    payment: { en: 'Payment via UPI QR', hi: 'यूपीआई QR से भुगतान' },
    payInstr: { en: 'Scan the QR to pay the Sankalp Dakshina. After payment, click Confirm.', hi: 'संकल्प दक्षिणा के लिए QR स्कैन करें। भुगतान के बाद पुष्टि करें।' },
    confirm: { en: 'Confirm Booking', hi: 'बुकिंग की पुष्टि करें' }
  },
  auth: {
    userLogin: { en: 'Devotee Login', hi: 'भक्त लॉगिन' },
    adminLogin: { en: 'Admin Login', hi: 'एडमिन लॉगिन' },
    panditLogin: { en: 'Pandit Login', hi: 'पंडित लॉगिन' },
    email: { en: 'Email', hi: 'ईमेल' },
    password: { en: 'Password', hi: 'पासवर्ड' },
    signIn: { en: 'Sign In', hi: 'साइन इन' },
    signUp: { en: 'Create Account', hi: 'खाता बनाएं' },
    noAccount: { en: "Don't have an account?", hi: 'खाता नहीं है?' },
    haveAccount: { en: 'Already have an account?', hi: 'पहले से खाता है?' },
    name: { en: 'Full Name', hi: 'पूरा नाम' }
  }
};

// Participation packages (matching navavidhabhakti.in style)
export const pujaPackages = [
  {
    id: 'individual',
    name_en: 'Individual',
    name_hi: '\u0935\u094d\u092f\u0915\u094d\u0924\u093f\u0917\u0924',
    price: 201,
    persons: 1,
    icon: 'User',
    desc_en: 'Pandit Ji will call out your name and gotra during the puja sankalp.',
    desc_hi: '\u092a\u0902\u0921\u093f\u0924 \u091c\u0940 \u0938\u0902\u0915\u0932\u094d\u092a \u0915\u0947 \u0938\u092e\u092f \u0906\u092a\u0915\u093e \u0928\u093e\u092e \u0914\u0930 \u0917\u094b\u0924\u094d\u0930 \u0932\u0947\u0902\u0917\u0947\u0964',
    features_en: ['1 Name & Gotra in Sankalp', 'Puja video recording', 'Optional Prasad delivery']
  },
  {
    id: 'couple',
    name_en: '2 Person',
    name_hi: '\u092f\u0941\u0917\u0932',
    price: 351,
    persons: 2,
    icon: 'Users',
    desc_en: 'Pandit Ji will call out 2 Devotees name and gotra during the puja sankalp.',
    desc_hi: '\u092a\u0902\u0921\u093f\u0924 \u091c\u0940 \u0938\u0902\u0915\u0932\u094d\u092a \u092e\u0947\u0902 2 \u092d\u0915\u094d\u0924\u094b\u0902 \u0915\u093e \u0928\u093e\u092e \u0932\u0947\u0902\u0917\u0947\u0964',
    features_en: ['2 Names & Gotra in Sankalp', 'Puja video recording', 'Optional Prasad delivery']
  },
  {
    id: 'family',
    name_en: 'Family',
    name_hi: '\u092a\u0930\u093f\u0935\u093e\u0930',
    price: 751,
    persons: 4,
    icon: 'Users',
    popular: true,
    desc_en: 'Pandit Ji will call out 4 Devotees name and gotra of your family.',
    desc_hi: '\u092a\u0902\u0921\u093f\u0924 \u091c\u0940 \u0906\u092a\u0915\u0947 \u092a\u0930\u093f\u0935\u093e\u0930 \u0915\u0947 4 \u092d\u0915\u094d\u0924\u094b\u0902 \u0915\u093e \u0928\u093e\u092e \u0932\u0947\u0902\u0917\u0947\u0964',
    features_en: ['4 Names & Gotra in Sankalp', 'Puja video recording', 'Free Prasad Delivery', 'Blessing certificate']
  },
  {
    id: 'joint_family',
    name_en: 'Joint Family',
    name_hi: '\u0938\u0902\u092f\u0941\u0915\u094d\u0924 \u092a\u0930\u093f\u0935\u093e\u0930',
    price: 1151,
    persons: 6,
    icon: 'HeartHandshake',
    desc_en: 'Pandit Ji will call out 6 Devotees name and gotra of your family.',
    desc_hi: '\u092a\u0902\u0921\u093f\u0924 \u091c\u0940 \u0906\u092a\u0915\u0947 \u092a\u0930\u093f\u0935\u093e\u0930 \u0915\u0947 6 \u092d\u0915\u094d\u0924\u094b\u0902 \u0915\u093e \u0928\u093e\u092e \u0932\u0947\u0902\u0917\u0947\u0964',
    features_en: ['6 Names & Gotra in Sankalp', 'Puja video recording', 'Free Prasad Delivery', 'Rudraksha Mala + Certificate']
  }
];

// Samagri / Add-on offerings catalog
export const samagriCatalog = [
  {
    id: 'vastra',
    name_en: 'Vastra Offering',
    name_hi: '\u0935\u0938\u094d\u0924\u094d\u0930 \u0905\u0930\u094d\u092a\u0923',
    desc_en: 'Silk vastra offered to the deity in your name',
    desc_hi: '\u0906\u092a\u0915\u0947 \u0928\u093e\u092e \u0938\u0947 \u0926\u0947\u0935\u0924\u093e \u0915\u094b \u0930\u0947\u0936\u092e\u0940 \u0935\u0938\u094d\u0924\u094d\u0930 \u0905\u0930\u094d\u092a\u0923',
    price: 151,
    image: 'https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?w=400',
    icon: 'Shirt'
  },
  {
    id: 'bhog',
    name_en: 'Bhog Offering',
    name_hi: '\u092d\u094b\u0917 \u0905\u0930\u094d\u092a\u0923',
    desc_en: 'Sattvik bhog prepared and offered to the deity',
    desc_hi: '\u0938\u093e\u0924\u094d\u0935\u093f\u0915 \u092d\u094b\u0917 \u0924\u0948\u092f\u093e\u0930 \u0915\u0930 \u0926\u0947\u0935\u0924\u093e \u0915\u094b \u0905\u0930\u094d\u092a\u093f\u0924',
    price: 101,
    image: 'https://images.unsplash.com/photo-1635952346904-95f2ccfcd029?w=400',
    icon: 'UtensilsCrossed'
  },
  {
    id: 'diya',
    name_en: '108 Diya Aarti',
    name_hi: '108 \u0926\u0940\u092f\u093e \u0906\u0930\u0924\u0940',
    desc_en: '108 diyas lit and offered in your Sankalp',
    desc_hi: '\u0906\u092a\u0915\u0947 \u0938\u0902\u0915\u0932\u094d\u092a \u092e\u0947\u0902 108 \u0926\u0940\u092f\u0947 \u092a\u094d\u0930\u091c\u094d\u0935\u0932\u093f\u0924',
    price: 251,
    image: 'https://images.unsplash.com/photo-1605292356183-a77d0a9c9d1d?w=400',
    icon: 'Flame'
  },
  {
    id: 'rudraksha',
    name_en: 'Panch Mukhi Rudraksha Mala',
    name_hi: '\u092a\u0902\u091a\u092e\u0941\u0916\u0940 \u0930\u0941\u0926\u094d\u0930\u093e\u0915\u094d\u0937 \u092e\u093e\u0932\u093e',
    desc_en: 'Energised Rudraksha mala home delivered after puja',
    desc_hi: '\u092a\u0942\u091c\u093e \u0915\u0947 \u092c\u093e\u0926 \u0918\u0930 \u092a\u0930 \u092d\u0947\u091c\u0940 \u091c\u093e\u0928\u0947 \u0935\u093e\u0932\u0940 \u090a\u0930\u094d\u091c\u093e\u0935\u093e\u0928 \u092e\u093e\u0932\u093e',
    price: 401,
    image: 'https://images.unsplash.com/photo-1622993361118-b6365d859ab6?w=400',
    icon: 'Gem'
  },
  {
    id: 'coconut',
    name_en: 'Nariyal & Chunri',
    name_hi: '\u0928\u093e\u0930\u093f\u092f\u0932 \u0914\u0930 \u091a\u0941\u0928\u0930\u0940',
    desc_en: 'Auspicious nariyal and chunri offered in your name',
    desc_hi: '\u0906\u092a\u0915\u0947 \u0928\u093e\u092e \u0938\u0947 \u092a\u0935\u093f\u0924\u094d\u0930 \u0928\u093e\u0930\u093f\u092f\u0932 \u0914\u0930 \u091a\u0941\u0928\u0930\u0940 \u0905\u0930\u094d\u092a\u0923',
    price: 121,
    image: 'https://images.unsplash.com/photo-1783255166269-90178ebcc03e?w=400',
    icon: 'Nut'
  },
  {
    id: 'prasad',
    name_en: 'Prasad Home Delivery',
    name_hi: '\u092a\u094d\u0930\u0938\u093e\u0926 \u0918\u0930 \u0921\u093f\u0932\u093f\u0935\u0930\u0940',
    desc_en: 'Blessed Prasad delivered to your home within 7-10 days',
    desc_hi: '\u0906\u0936\u0940\u0930\u094d\u0935\u093e\u0926 \u092a\u094d\u0930\u093e\u092a\u094d\u0924 \u092a\u094d\u0930\u0938\u093e\u0926 7-10 \u0926\u093f\u0928 \u092e\u0947\u0902 \u0906\u092a\u0915\u0947 \u0918\u0930',
    price: 149,
    image: 'https://images.pexels.com/photos/8887017/pexels-photo-8887017.jpeg?auto=compress&cs=tinysrgb&w=400',
    icon: 'Package'
  },
  {
    id: 'yantra',
    name_en: 'Shubh Yantra',
    name_hi: '\u0936\u0941\u092d \u092f\u0902\u0924\u094d\u0930',
    desc_en: 'Energised yantra for home / puja room',
    desc_hi: '\u0918\u0930 / \u092a\u0942\u091c\u093e \u0915\u0915\u094d\u0937 \u0915\u0947 \u0932\u093f\u090f \u090a\u0930\u094d\u091c\u093e\u0935\u093e\u0928 \u092f\u0902\u0924\u094d\u0930',
    price: 351,
    image: 'https://upload.wikimedia.org/wikipedia/commons/8/88/Sri_Yantra_copper.jpg',
    icon: 'Sparkles'
  },
  {
    id: 'kalash',
    name_en: 'Kalash Sthapana',
    name_hi: '\u0915\u0932\u0936 \u0938\u094d\u0925\u093e\u092a\u0928\u093e',
    desc_en: 'Special kalash sthapana ritual in your name',
    desc_hi: '\u0906\u092a\u0915\u0947 \u0928\u093e\u092e \u0938\u0947 \u0935\u093f\u0936\u0947\u0937 \u0915\u0932\u0936 \u0938\u094d\u0925\u093e\u092a\u0928\u093e',
    price: 201,
    image: 'https://images.unsplash.com/photo-1764304589223-30bfbfdaa9ef?w=400',
    icon: 'Trophy'
  }
];

// Auth mock storage helpers
export const mockUsers = [
  { email: 'admin@navavidhabhakti.com', password: 'admin123', role: 'admin', name: 'Admin' },
  { email: 'demo@navavidhabhakti.com', password: 'user123', role: 'user', name: 'Devotee' }
];

// Default Pandit Jis list (admin manages these)
export const defaultPandits = [
  {
    id: 'pd1',
    name_en: 'Acharya Ramesh Sharma',
    name_hi: '\u0906\u091a\u093e\u0930\u094d\u092f \u0930\u092e\u0947\u0936 \u0936\u0930\u094d\u092e\u093e',
    experience: 18,
    specialization_en: 'Vedic Rituals, Rudrabhishek, Navagraha Puja',
    specialization_hi: '\u0935\u0948\u0926\u093f\u0915 \u0905\u0928\u0941\u0937\u094d\u0920\u093e\u0928, \u0930\u0941\u0926\u094d\u0930\u093e\u092d\u093f\u0937\u0947\u0915, \u0928\u0935\u0917\u094d\u0930\u0939 \u092a\u0942\u091c\u093e',
    temple_en: 'Kashi Vishwanath, Varanasi',
    temple_hi: '\u0915\u093e\u0936\u0940 \u0935\u093f\u0936\u094d\u0935\u0928\u093e\u0925, \u0935\u093e\u0930\u093e\u0923\u0938\u0940',
    phone: '+91 9876543210',
    photo: 'https://images.pexels.com/photos/8887012/pexels-photo-8887012.jpeg?auto=compress&cs=tinysrgb&w=400'
  },
  {
    id: 'pd2',
    name_en: 'Pandit Suresh Tripathi',
    name_hi: '\u092a\u0902\u0921\u093f\u0924 \u0938\u0941\u0930\u0947\u0936 \u0924\u094d\u0930\u093f\u092a\u093e\u0920\u0940',
    experience: 25,
    specialization_en: 'Maha Rudra, Chandi Path, Grah Shanti',
    specialization_hi: '\u092e\u0939\u093e \u0930\u0941\u0926\u094d\u0930, \u091a\u0902\u0921\u0940 \u092a\u093e\u0920, \u0917\u094d\u0930\u0939 \u0936\u093e\u0902\u0924\u093f',
    temple_en: 'Baba Baidyanath Dham, Deoghar',
    temple_hi: '\u092c\u093e\u092c\u093e \u092c\u0948\u0926\u094d\u092f\u0928\u093e\u0925 \u0927\u093e\u092e, \u0926\u0947\u0935\u0918\u0930',
    phone: '+91 9876500001',
    photo: 'https://images.pexels.com/photos/6994959/pexels-photo-6994959.jpeg?auto=compress&cs=tinysrgb&w=400'
  },
  {
    id: 'pd3',
    name_en: 'Pandit Mahesh Joshi',
    name_hi: '\u092a\u0902\u0921\u093f\u0924 \u092e\u0939\u0947\u0936 \u091c\u094b\u0936\u0940',
    experience: 12,
    specialization_en: 'Lakshmi Puja, Ganesh Puja, Havan',
    specialization_hi: '\u0932\u0915\u094d\u0937\u094d\u092e\u0940 \u092a\u0942\u091c\u093e, \u0917\u0923\u0947\u0936 \u092a\u0942\u091c\u093e, \u0939\u0935\u0928',
    temple_en: 'Mahakaleshwar, Ujjain',
    temple_hi: '\u092e\u0939\u093e\u0915\u093e\u0932\u0947\u0936\u094d\u0935\u0930, \u0909\u091c\u094d\u091c\u0948\u0928',
    phone: '+91 9876500002',
    photo: 'https://images.pexels.com/photos/7288118/pexels-photo-7288118.jpeg?auto=compress&cs=tinysrgb&w=400'
  }
];

// Default QR (mock UPI QR image - decorative placeholder)
export const defaultQR = 'https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=upi://pay?pa=7250412100@upi&pn=NavavidhaBhakti&cu=INR';

export const contactInfo = {
  name: 'Navavidha Bhakti',
  address: 'Williams Town, Deoghar, Jharkhand 814112',
  landmark: 'Tower Chowk',
  city: 'Deoghar',
  state: 'Jharkhand',
  pincode: '814112',
  phone: '+91 7250412100',
  email: 'navavidhabhakti001@gmail.com',
  domain: 'navavidhabhakti.com',
  whatsapp: '917250412100'
};
